import React, { useId, useRef, useState } from "react";
import useDismissOnOutside from "../../components/useDismissOnOutside";

/**
 * One small button replacing two wide ones. The scope ("All 1,513 filtered" /
 * "12 selected") is stated once above the choices rather than repeated in both
 * labels, so the items name only what differs between them.
 *
 * Structure mirrors ColumnPicker so the two sit consistently in the filter bar.
 */
export default function ExportMenu({
  scopeLabel,
  onExportInvoices,
  onExportWithLines,
  busy,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const scopeId = useId();

  useDismissOnOutside(ref, open, () => setOpen(false));

  const choose = (handler) => () => {
    setOpen(false);
    handler();
  };

  const item =
    "w-full text-left px-3 py-1.5 text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <span ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        className="border border-gray-300 rounded-md px-3 py-2 text-sm bg-white hover:bg-gray-50"
      >
        {busy ? "Exporting…" : "Export ▾"}
      </button>
      {open && (
        <div
          role="menu"
          className="absolute right-0 z-40 mt-1 bg-white border rounded-md shadow-lg py-1 min-w-[200px]"
        >
          <div id={scopeId} className="px-3 py-1 text-xs text-gray-500">
            {scopeLabel}
          </div>
          <button
            type="button"
            role="menuitem"
            className={item}
            aria-describedby={scopeId}
            onClick={choose(onExportInvoices)}
          >
            Invoices
          </button>
          <button
            type="button"
            role="menuitem"
            className={item}
            aria-describedby={scopeId}
            disabled={busy}
            onClick={choose(onExportWithLines)}
          >
            {busy ? "Exporting…" : "Invoices with lines"}
          </button>
        </div>
      )}
    </span>
  );
}
